/**
 * SiteInactiveCard.js
 *
 * A card displayed when the selected site exists in the database but is not yet active.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { RocketLaunchIcon } from '@heroicons/react/24/solid';
import titleCase from '@/utils/titleCase';

SiteInactiveCard.propTypes = {
  siteData: PropTypes.object.isRequired,
};

/**
 * Displays a message for a site found in the system but not yet active.
 *
 * @param {object} props - Component props.
 * @returns {JSX.Element} The rendered inactive site card.
 */
function SiteInactiveCard(props) {
  const { siteData } = props;
  return (
    <div className="bg-cs-blue-100 border border-cs-blue-500 rounded-2xl flex gap-2 items-start px-4 pt-4 pb-5">
      <RocketLaunchIcon className="w-[22px] h-[22px] text-cs-blue-500 shrink-0 mt-0.5" />
      <div className="flex flex-col gap-4 flex-1">
        <div className="flex flex-col gap-4">
          <p className="font-semibold text-base text-gray-700 leading-[1.2] tracking-[-0.17px]">
            Thanks! We found your site – now let&apos;s get it set up.
          </p>
          <p className="text-base text-gray-700 leading-[1.2] tracking-[-0.16px]">
            We&apos;ll help gather what&apos;s needed to activate your school or organization. In the
            meantime, you can explore opportunities on the platform.
          </p>
          <p className="text-base text-gray-700 leading-[1.2] tracking-[-0.16px]">
            Please check that the information below is correct.
          </p>
        </div>
        <div className="text-base font-semibold text-gray-700 leading-[1.2] tracking-[-0.16px]">
          <p>{siteData.name}</p>
          <p>{titleCase(siteData.addressLine1 || '')}</p>
          <p>{siteData.city} {siteData.state}, {siteData.zipCode}</p>
        </div>
      </div>
    </div>
  );
}

export default SiteInactiveCard;
